<cfp-card [fullHeight]="true">
  <div class="d-flex">
    <h2 class="card-title" [innerHtml]="title() || propertyNames()[0] | translate"></h2>
    <div class="ms-auto d-print-none">
      @if (showDropdown()) {
        <cfp-dropdown
          [icon]="'ellipsis-v'"
          [ariaLabel]="'show' | translate"
          [formControlSize]="'small'"
          class="cfp-dropdown-options"
          [id]="'switch-between-chart-states'"
        >
          <div class="dropdown-title">{{ 'show' | translate }}</div>
          <cfp-input-radio
            [radioValue]="false"
            [name]="'showCumulative_' + (title() || propertyNames()[0])"
            [id]="'showCumulative_' + (title() || propertyNames()[0]) + 'True'"
            [ngModel]="cumulative()"
            (ngModelChange)="setCumulative(false)"
            [label]="'yearly' | translate"
          />
          <cfp-input-radio
            [radioValue]="true"
            [name]="'showCumulative_' + (title() || propertyNames()[0])"
            [id]="'showCumulative_' + (title() || propertyNames()[0]) + 'False'"
            [ngModel]="cumulative()"
            (ngModelChange)="setCumulative(true)"
            [label]="'cumulative' | translate"
          />
        </cfp-dropdown>
      } @else {
        <cfp-button-group [ariaLabel]="'aria.label.toggleYearlyCumulativeChart' | translate">
          <li>
            <cfp-button-toggle
              liveRegionStatusUpdater
              [statusUpdateOnClick]="'charts.liveAreaRegion.yearly' | translate"
              (clicked)="setCumulative(false)"
              [pressed]="!cumulative()"
            >
              {{ 'yearly' | translate }}
            </cfp-button-toggle>
          </li>
          <li>
            <cfp-button-toggle
              liveRegionStatusUpdater
              [statusUpdateOnClick]="'charts.liveAreaRegion.cumulative' | translate"
              (clicked)="setCumulative(true)"
              [pressed]="cumulative()"
            >
              {{ 'cumulative' | translate }}
            </cfp-button-toggle>
          </li>
        </cfp-button-group>
      }
    </div>
  </div>
  @if (chartOptions() && chartData()) {
    <div class="chart-responsive" aria-hidden="true">
      <div class="chart-wrapper">
        <canvas
          class="chart-canvas"
          baseChart
          [datasets]="chartData().datasets"
          [labels]="chartData().labels"
          [type]="chartType()"
          [options]="chartOptions()"
          [plugins]="barChartPlugins"
          role="img"
          [attr.aria-label]="
            getTranslation('roadmapChart.ariaLabel.' + propertyNames()[0] + (cumulative() ? '.cumulative' : ''))
          "
          width="500"
          height="250"
        >
        </canvas>
      </div>
    </div>
  }
  <div class="mt-2 d-print-none">
    <cfp-link
      (click)="showData()"
      liveRegionStatusUpdater
      [statusUpdateOnClick]="'charts.liveAreaRegion.showdata' | translate"
      >{{ 'show.data' | translate }}
      <cfp-icon [icon]="'angle-right'" />
    </cfp-link></div
></cfp-card>
